//https://tools.hubteam.com/launch/limits/1153/parcels crm-index-page-pinned-views-limit
export const getPinnedViewLimit = ({
  crmIndexPagePinnedViewsLimit
} = {
  crmIndexPagePinnedViewsLimit: 5
}) => crmIndexPagePinnedViewsLimit;

//WARN - it is important that maxNumberOfViewsToQuickFetch stays equal to the largest possible value for //https://tools.hubteam.com/launch/limits/1153/parcels crm-index-page-pinned-views-limit
export const maxNumberOfViewsToQuickFetch = 50;